import {Button, Grid2, Typography} from "@mui/material";
import {color_green} from "@/agentur/AgenturColors";
import * as React from "react";
import {scrollToNextSection} from "@/lib/utils";
import {Section7DTO} from "@/pages/landing-page/landing-page-data";
import {LANDING_HEADLINE_SMALL, LANDING_LEAD} from "@/pages/landing-page/utils/landing-font-sizes";
import {COMPACT_SECTION_MIN_HEIGHT} from "@/pages/landing-page/utils/landing-section-layout";

interface Section7Props {
    data: Section7DTO;
    contactRef: React.RefObject<any>;
}

export const Section7 = ({ contactRef, data }: Section7Props) => (
    <Grid2
        container
        direction="column"
        paddingTop={4}
        sx={{
            minHeight: COMPACT_SECTION_MIN_HEIGHT,
            position: "relative",
            px: {
                md: 1,
                lg: 10
            }
        }}
    >
        <Grid2 width="100%">
            <Typography sx={{ fontSize: LANDING_HEADLINE_SMALL }}>{data.title}</Typography>
        </Grid2>
        <Grid2
            maxWidth="900px"
            sx={{
                paddingTop: {
                    xs: 2,
                    md: 10
                }
            }}
        >
            <Typography sx={{ fontSize: LANDING_LEAD }}>{data.text}</Typography>
        </Grid2>
        <Grid2 paddingTop={8} maxWidth="900px">
            <Button
                variant="contained"
                sx={{
                    backgroundColor: color_green[2],
                    color: "#000080",
                    fontWeight: "bold",
                    mt: 2,
                    padding: "8px 24px"
                }}
                onClick={() => scrollToNextSection(contactRef)}
            >
                {data.cta}
            </Button>
        </Grid2>
    </Grid2>
);
